<div id="appointmentCancelPopup">
  <div class="mat-dialog-header">
    <h1 mat-dialog-title>
      <span>{{ 'agent:popin.cancel_appointment.title' | translate }}</span>
    </h1>
    <div class="actions-container">
      <button mat-icon-button class="close-button" (click)="cancel()">
        <span class="nodisplay">
          {{ 'commons:basic.closePopup' | translate }}"{{ 'agent:popin.cancel_appointment.title' | translate }}"
        </span>
      </button>
    </div>
  </div>
  <mat-dialog-content>
    <div class="appointmentCancelLabel" *ngIf="initDone">
      {{ 'agent:popin.cancel_appointment.comments_tip' | translate }}
    </div>
    <div *ngIf="!initDone" class="error">
      {{ 'agent:popin.cancel_appointment.error_initiation' | translate }}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button class="cng-ico_check" (click)="submitForm()" [disabled]="!initDone">
      {{ 'agent:actions.validate' | translate }}
    </button>
    <button mat-button class="cng-ico_annuler" (click)="cancel()">
      {{ 'agent:actions.cancel' | translate }}
    </button>
  </mat-dialog-actions>
</div>
